import React, {useEffect, useMemo} from "react";
import {
    Autocomplete,
    Button,
    Checkbox,
    DownloadIcon,
    FilterRemoveIcon,
    Heading,
    IconButton,
    Pagination,
    Pane,
    Paragraph,
    RemoveIcon,
    SearchInput,
    Select,
    SortDescIcon,
    SortIcon,
    Table,
    toaster,
    Tooltip,
    UpdatedIcon
} from "evergreen-ui";
import {
    deleteOutputFormById,
    deleteOutputFormsByIds,
    downloadOutputFormFileById,
    downloadOutputFormsFiles,
    getAll
} from "./Api";
import {getOutputFormRights} from "../Privileges/PrivilegesSelectors";
import {useSelector} from "react-redux";
import SuspenseSpinner from "../../Utils/SuspenseSpinner";
import {selectorStationsForFilters} from "../Constructor/periodValuesFilterApi";
import DeleteOFDialog from "./dialogs/DeleteDialog";
import {getFileNameFromContentDisposition} from "../Constructor/common/ApiCommon";
import {AutoCompleteMaterials} from "../BaseMaterials/BaseMaterials";


export default function OutputForms() {
    const privileges = useSelector(state => state.login.privileges)
    const rights = getOutputFormRights(privileges);

    const [outputForms, setOutputForms] = React.useState([])
    const [shouldUpdate, setShouldUpdate] = React.useState(false)
    const [isRemoveWindowShown, setIsRemoveWindowShown] = React.useState(false)
    const [isRemoveGroupWindowShown, setIsRemoveGroupWindowShown] = React.useState(false)
    const [deleteId, setDeleteId] = React.useState()

    const stations = useSelector(selectorStationsForFilters);

    const [stn, setStn] = React.useState('')
    const [templateName, setTemplateName] = React.useState('')
    const [outputFormName, setOutputFormName] = React.useState('')

    const [resortStationName, setResortStationName] = React.useState(true)
    const [resortOFName, setResortOFName] = React.useState(true)
    const [resortCreationDate, setResortCreationDate] = React.useState(false)
    const [resortTemplateName, setResortTemplateName] = React.useState(true)
    const [resortPeriod, setResortPeriod] = React.useState(false)
    const [isFetch, setIsFetch] = React.useState(false)

    const [curPage, setCurPage] = React.useState(1)
    const [totalPages, setTotalPages] = React.useState(0)
    const [lastRequestFilters, setLastRequestFilters] = React.useState(new Map())

    const [selectedIds, setSelectedIds] = React.useState([])

    const [elementsPerPage, setElementsPerPage] = React.useState(10)

    const lastSortEnum = {
        NAME: "NAME",
        STATION: "STATION",
        CREATION_DATE: "CREATION_DATE",
        TEMPLATE: "TEMPLATE",
        PERIOD: "PERIOD",
        DATASOURCES: "DATASOURCES"
    }

    const [lastSort, setLastSort] = React.useState(lastSortEnum.CREATION_DATE)
    const [lastOrder, setLastOrder] = React.useState(false)

    function changeElementsPerPage(number) {
        setCurPage(1)
        setElementsPerPage(number)
        setShouldUpdate(!shouldUpdate)
    }

    function onFilterPress(e)  {
        if (e.key === 'Enter') {
            onUpdate()
        }
    }

    function changePage(page) {
        setCurPage(page)
        setShouldUpdate(!shouldUpdate)
    }

    function clearFilter() {
        setStn('')
        setOutputFormName('')
        setTemplateName('')
        setShouldUpdate(!shouldUpdate)
    }

    function getFilters() {
        let filters = new Map();
        if (stn.length !== 0) {
            filters.set('stationName', stn)
        }
        if (templateName.length !== 0) {
            filters.set('templateName', templateName)
        }

        if (outputFormName.length !== 0) {
            filters.set('outputForm', outputFormName)
        }
        filters.set('pageNum', (curPage - 1))
        filters.set('elsPerPage', elementsPerPage)

        return filters
    }

    function deleteGroup() {
        deleteOutputFormsByIds([... new Set(selectedIds)]).then(() => {
            setShouldUpdate(!shouldUpdate)
            setIsRemoveGroupWindowShown(false)
            toaster.success("Успешно удалены!")
        }).catch(() => {
            toaster.danger("Не удалось удалить выбранные элементы!")
        })
    }

    function sort(asc, sort) {
        setLastOrder(asc)
        setLastSort(sort)

        getAll(lastRequestFilters, sort, asc).then(res => {
            setOutputForms(res.data.content)
            setCurPage(res.data.pageable.pageNumber + 1)
            setTotalPages(res.data.totalPages)
            setIsFetch(false)
        })
    }

    useEffect(() => {
            setIsFetch(true)
            const filters = getFilters();
            setLastRequestFilters(filters)
            getAll(filters, lastSort, lastOrder).then(res => {
                setOutputForms(res.data.content)
                setCurPage(res.data.pageable.pageNumber + 1)
                setTotalPages(res.data.totalPages)
                setIsFetch(false)
            })
        },
        [shouldUpdate])

    useMemo(() => {
        switch (lastSort) {
            case lastSortEnum.NAME:
                sort(resortOFName, lastSortEnum.NAME)
                break
            case lastSortEnum.STATION:
                sort(resortStationName, lastSortEnum.STATION)
                break
            case lastSortEnum.CREATION_DATE:
                sort(resortCreationDate, lastSortEnum.CREATION_DATE)
                break
            case lastSortEnum.TEMPLATE:
                sort(resortTemplateName, lastSortEnum.TEMPLATE)
                break
            case lastSortEnum.PERIOD:
                sort(resortPeriod, lastSortEnum.PERIOD)
                break
        }
    }, [resortStationName, resortCreationDate, resortOFName, resortTemplateName, resortPeriod])

    function onUpdate() {
        setCurPage(1)
        setShouldUpdate(!shouldUpdate)
    }

    function onDownloadFileAction(id, filename) {
        downloadOutputFormFileById(id).then(
            (res) => {
                const filename = getFileNameFromContentDisposition(res.headers['content-disposition'])
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename); //or any other extension
                document.body.appendChild(link);
                link.click();
            }
        )
    }

    function downloadFiles() {
        downloadOutputFormsFiles(selectedIds).then(
            (res) => {
                const url  = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', "files" + '.zip'); //or any other extension
                document.body.appendChild(link);
                link.click();
            }
        )
    }

    function selectRow(id, shouldAdd) {
        if (shouldAdd) {
            console.log(selectedIds)
            selectedIds.push(id)
            setSelectedIds([...selectedIds])
        } else {
            const index = selectedIds.indexOf(id);
            if (index !== -1) {
                console.log(selectedIds)
                selectedIds.splice(index, 1)
                setSelectedIds([...selectedIds]);

            }
        }
    }

    function isRowChecked(id) {
        console.log("ID " + id)
        console.log("CHECKING... " + id + " RESULT: " + selectedIds.includes(id))
        return selectedIds.includes(id)
    }

    function onDeleteConfirmAction() {
        deleteOutputFormById(deleteId).then(
            (res) => {
                toaster.success("Успешно удалили!")
                setIsRemoveWindowShown(false)
                setShouldUpdate(!shouldUpdate)
            }
        ).catch(
            () => {
                toaster.danger("Не удалось удалить!")
                setIsRemoveWindowShown(false)
                setShouldUpdate(!shouldUpdate)
            }
        )
    }


    return (
        <Pane margin={40} height={320 +  outputForms.length * 40}>
            <Pane>
                <Heading size={600}>Выходные формы материалов наблюдений</Heading>
            </Pane>
            <Pane
                display="flex"
                marginTop={10}
                marginBottom={20}
                columnGap={12}
                gridTemplateRows="max-content max-content"
                gridRowGap=".5em"
                alignItems="center"
            >
                <Pane>
                    {AutoCompleteMaterials(setStn, stations, stn, onFilterPress)}
                </Pane>

                <SearchInput
                    placeholder="Введите наименование шаблона"
                    onKeyPress={(e) => onFilterPress(e)}
                    value={templateName}
                    onChange={e => setTemplateName(e.target.value)}
                />

                <SearchInput
                    placeholder="Введите наименование файла"
                    onKeyPress={(e) => onFilterPress(e)}
                    value={outputFormName}
                    onChange={e => setOutputFormName(e.target.value)}
                />

                <Tooltip content="Обновить">
                    <IconButton icon={UpdatedIcon} onClick={() => onUpdate()}/>
                </Tooltip>

                <Tooltip content="Сбросить">
                    <IconButton icon={FilterRemoveIcon} onClick={() => clearFilter()}/>
                </Tooltip>
            </Pane>
            <Pane display={"flex"} gap={10}>
                <Button disabled={selectedIds.length === 0} onClick={() => downloadFiles()}>Скачать</Button>
                {rights.canRemove ? <Button disabled={selectedIds.length === 0} onClick={() => setIsRemoveGroupWindowShown(true)}>Удалить</Button> : <></> }
            </Pane>

            {isFetch ? <SuspenseSpinner/> : <Pane>
                <Table marginTop={8} >
                    <Table.Head>
                        <Table.TextHeaderCell flexBasis={45} flexShrink={0} flexGrow={0}></Table.TextHeaderCell>
                        <Table.TextHeaderCell onClick={() => {setResortStationName(!resortStationName); setLastSort(lastSortEnum.STATION); }} isSelectable rightView={resortStationName ? <SortIcon/> : <SortDescIcon/>}>
                            Название станции
                        </Table.TextHeaderCell>
                        <Table.TextHeaderCell flexBasis={80} onClick={() => {setResortPeriod(!resortPeriod); setLastSort(lastSortEnum.PERIOD)}} isSelectable rightView={resortPeriod ? <SortIcon/> : <SortDescIcon/>}>
                            Период
                        </Table.TextHeaderCell>
                        <Table.TextHeaderCell onClick={() => {setResortTemplateName(!resortTemplateName); setLastSort(lastSortEnum.TEMPLATE)}} isSelectable rightView={resortTemplateName ? <SortIcon/> : <SortDescIcon/>}>Шаблон</Table.TextHeaderCell>
                        <Table.TextHeaderCell onClick={() => {setResortOFName(!resortOFName); setLastSort(lastSortEnum.NAME)}} isSelectable rightView={resortOFName ? <SortIcon/> : <SortDescIcon/>}>
                            Наименование файла
                        </Table.TextHeaderCell>
                        <Table.TextHeaderCell onClick={() => {setResortCreationDate(!resortCreationDate); setLastSort(lastSortEnum.CREATION_DATE)}} isSelectable rightView={resortCreationDate ? <SortIcon/> : <SortDescIcon/>}>
                            Дата формирования
                        </Table.TextHeaderCell>
                        <Table.TextHeaderCell flexBasis={80}>Меню</Table.TextHeaderCell>
                    </Table.Head>
                    <Table.VirtualBody height={outputForms.length * 40}>
                        {outputForms.map(of =>
                            <Table.Row isSelected={isRowChecked(of.id)} height={40}>
                                <Table.Cell flexBasis={45} flexShrink={0} flexGrow={0}>
                                    <Checkbox checked={isRowChecked(of.id)}
                                              onChange={event => selectRow(of.id, event.target.checked)}
                                    />
                                </Table.Cell>
                                <Table.TextCell>{of.stationName}</Table.TextCell>
                                <Table.TextCell flexBasis={80}>{of.formattedPeriod ? of.formattedPeriod : ""}</Table.TextCell>
                                <Table.TextCell>{of.templateName == null? '-': of.templateName}</Table.TextCell>
                                <Table.TextCell>{of.filename}</Table.TextCell>
                                <Table.TextCell>{of.creationDate}</Table.TextCell>
                                <Table.Cell flexBasis={80} gap={5}>
                                    {
                                        rights.canDownload ?
                                            <Tooltip content="Скачать">
                                                <IconButton icon={DownloadIcon}
                                                            disabled={selectedIds.length !== 0}
                                                            onClick={() => {
                                                                onDownloadFileAction(of.id, of.filename)
                                                            }}/>
                                            </Tooltip>
                                            : <></>
                                    }

                                    {
                                        rights.canRemove ?
                                            <Tooltip content="Удалить">
                                                <IconButton icon={RemoveIcon}
                                                            disabled={selectedIds.length !== 0}
                                                            onClick={() => {
                                                                setIsRemoveWindowShown(true)
                                                                setDeleteId(of.id)
                                                            }}/>
                                            </Tooltip>
                                            : <></>
                                    }
                                </Table.Cell>
                            </Table.Row>
                        )}

                    </Table.VirtualBody>
                </Table>
                <Pane display={"flex"} alignItems={"center"} justifyContent={"center"} margin={10}>
                    <Pagination page={curPage}
                                totalPages={totalPages}
                                onPageChange={(page) => changePage(page)}
                                onNextPage={() => changePage(curPage + 1)}
                                onPreviousPage={() => changePage(curPage - 1)}
                    />
                </Pane>
                <Pane justifyContent={"right"} verticalAlign={"right"} display={"flex"} marginRight={40} marginTop={-37}>
                    <Paragraph>Показывать по</Paragraph>
                    <Pane>
                        <Select value={elementsPerPage} onChange={event => changeElementsPerPage(event.target.value)} marginLeft={10}>
                            <option value={"5"}>5</option>
                            <option value={"10"}>10</option>
                            <option value={"15"}>15</option>
                            <option value={"20"}>20</option>
                        </Select>
                    </Pane>

                </Pane>
            </Pane>}

            <DeleteOFDialog setIsShown={(shown) => setIsRemoveWindowShown(shown)}
                            isShown={isRemoveWindowShown}
                            deleteAction={() => onDeleteConfirmAction()}
                            text={"Данная выходная форма будет удалена. Продолжить?"}
                            title={"Удалить выходную форму"}
            />

            <DeleteOFDialog setIsShown={(shown) => setIsRemoveGroupWindowShown(shown)}
                            isShown={isRemoveGroupWindowShown}
                            deleteAction={() => deleteGroup()}
                            text={"Данные выходные формы будут удалены. Продолжить?"}
                            title={"Удалить выходные формы"}
            />

        </Pane>

    );
}